import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { User, UserState } from "./User.type";
import { getUsers, addUser, updateUser, deleteUser, getRecentUsers } from "./UserService";

const initialState: UserState = {
  users: [],
  status: "idle",
  error: null,
};

// Thunks
export const fetchUsersAsync = createAsyncThunk(
  "users/fetchUsers",
  async () => {
    const response = await getUsers();
    return response;
  }
);

export const fetchRecentUsersAsync = createAsyncThunk(
  "users/fetchRecentUsers",
  async (recordCount: number) => {
    const response = await getRecentUsers(recordCount);
    return response;
  }
);


export const createUserAsync = createAsyncThunk(
  "users/createUser",
  async (user: User) => {
    const response = await addUser(user);
    return response;
  }
);

export const editUserAsync = createAsyncThunk(
  "users/editUser",
  async (user: User) => {
    const response = await updateUser(user);
    return response;
  }
);

export const removeUserAsync = createAsyncThunk(
  "users/removeUser",
  async (userId: number) => {
    await deleteUser(userId);
    return userId;
  }
);

// Slice
const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Users
      .addCase(fetchUsersAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsersAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload;
      })
      .addCase(fetchUsersAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })

      // Create User
      .addCase(createUserAsync.fulfilled, (state, action) => {
        state.users.push(action.payload);
      })

      // Edit User
      .addCase(editUserAsync.fulfilled, (state, action) => {
        const index = state.users.findIndex(
          (user) => user.id === action.payload.id
        );
        if (index !== -1) {
          state.users[index] = action.payload;
        }
      })

      // Remove User
      .addCase(removeUserAsync.fulfilled, (state, action) => {
        state.users = state.users.filter((user) => user.id !== action.payload);
      });
  },
});

export default userSlice.reducer;
